<template>

  <div class="privacy_agreement">
    <div class="swiper-slide swiper_md">
      <h3 class="ys_title">一号车市隐私权政策</h3>
      <p class="label ys_date">2024年3月12日</p>
      <p class="label ys_txt"><span class="ys_indent2">武汉一号车市科技有限公司（以下简称“一号车市”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。一号车市致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，一号车市承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">本政策适用于一号车市所有的产品及服务（包括客如意APP)，如一号车市提供的产品或服务中未设独立隐私权政策的，则本政策同样适用于该部分产品或服务。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">请在使用客如意APP前，仔细阅读并了解本《隐私权政策》。一旦开始使用客如意APP，即表示您已知晓并同意本隐私权政策的全部内容。</span></p>
      <p class="label ys_stage">一、信息的收集范围</p>
      <p class="label ys_txt"><span class="ys_indent2">我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">1.个人相关信息：当您选择一号车市提供的相关服务时，根据您选择的服务类型可能需向一号车市提交个人<span class="jiacu">身份证、手机号、公司名称、地址、邮箱、车辆信息、金融购车申请、授权委托书、征信记录、驾驶证、行驶证、银行卡、社保缴纳信息、银行流水、AndroidID等相关个人信息。</span></span>
      </p>
      <p class="label  ys_txt"><span class="ys_indent2">2.您的密码、密码提示以及其他可用于验证和访问您的账户的安全信息。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">3.处理您付款操作所必须的数据，如您的银行卡号或第三方支付账户名等支付工具，以及与该支付工具相关的安全码。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">4.当您使用客如意APP时，服务器会自动记录一些信息，包括但不限于使用情况、IP地址、所访问服务的URL、浏览器的类型、访问的地理位置、访问的车辆信息、访问日期和时间等日志。</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">5.某些产品和/或服务包含唯一应用程序编号。当您安装、激活、更新、卸载相关服务或当这些服务定期与一号车市产品通信（例如软件的更新）时，系统会将此编号以及与安装相关的信息（例如操作系统类型和应用程序版本号）发送给一号车市。当您使用具有定位功能的一号车市产品服务时，系统会自动处理有关设备的位置信息，以使得您不需要手动输入自身地理坐标就可获得相关服务。
          为了提供更好的服务与改善用户体验，一号车市可能会记录硬件型号、操作系统版本号、国际移动设备身份码（IMEI）、网络设备硬件地址（MAC）等信息。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">6.为使您获得更轻松的访问体验，您访问客如意APP时，我们可能会通过Cookies小型数据文件识别您的身份，这么做是帮您简化重复登录的步骤、帮助判断您的账户安全、存储您的使用偏好等。一号车市不会将
          Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有
          Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
          Cookies；另外，您也可以清除浏览器内保存的所有Cookies，移动端退出登录后也可以清除所有Cookies。但如果您这么做，您可能需要在每一次访问一号车市产品时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
        </span></p>
      <p class="label ys_txt"><span class="ys_indent2">7.其他根据一号车市产品及服务的需要而收集的您的个人信息，包括但不限于您对一号车市及一号车市的产品及服务的意见、建议等信息。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">8.注销/删除账户</span></p>
      <p class="label ys_txt"><span class="ys_indent2">您可以申请注销/删除账户。可前往我的页面点击安全中心，再点击注销账号按钮，弹窗是否确定注销选择是，则会立即注销完成。您注销/删除后，我们将停止为您提供产品与服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。账户一旦被注销/删除将不可恢复，请您在操作之前自行备份账户相关的所有信息和数据。注销账户后，您将无法再使用本账户，也将无法找回您账户中及与账户相关的任何内容或信息。</span>
      </p>
      <p class="label ys_stage">二、信息的收集方式</p>
      <p class="label ys_txt"><span class="ys_indent2">客如意APP将会收集及储存您在使用过程中输入的资料，或您在使用客如意APP的过程中以其他任何方式向我们提供的信息。我们亦可能从关联公司、商业伙伴和/或其他独立第三方处，获取与您有关并由该等第三方主体合法收集的资料或信息；您在相关站点和/或与改等第三方所作的隐私设定，可能会限制或阻止我们对有关前述资料或信息的查阅。
          若您提供信息予我们，即表示您接受，一号车市将在所需期限内留存您的信息以履行有关用途。</span></p>
      <p class="label ys_stage">三、信息的收集用途</p>
      <p class="label ys_txt"><span class="ys_indent2">1.向您提供一号车市的产品及服务，并进行一号车市产品的维护和优化； </span></p>
      <p class="label ys_txt"><span class="ys_indent2">2.我们可能使用您提供的个人信息中的联系方式与您通信，例如通知您有关您的账户、安全性更新、产品和服务信息。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">3.开展一号车市产品及服务相关的市场活动，向您推送最新的市场活动信息及优惠方案；</span></p>
      <p class="label ys_txt"><span class="ys_indent2">4.一号车市可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们或其他关联方协议、政策或规则的行为，以保护您和其他用户，以及我们和其他关联方的合法权益</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">5.协助行政机关、司法机构等有权机关开展调査，并遵守适用法律法规及其他向有权机关承诺之义务；</span></p>
      <p class="label ys_txt"><span class="ys_indent2">6.在收集信息之时所通知您的用途以及与上述任何用途有关的其他用途；
          此外，一号车市可能向您发送与上述用途有关的信息和通知，包括但不限于为保证服务完成所必须的验证码、使用产品或服务时所必要的推送通知、关于一号车市产品或服务的新闻以及市场活动及优惠促销信息。
        </span></p>
      <p class="label ys_txt"><span class="ys_indent2"> </span></p>
      <p class="label ys_txt"><span class="ys_indent2"> </span></p>
      <p class="label ys_txt"><span class="ys_indent2"> </span></p>
      <p class="label ys_stage">四、信息共享</p>
      <p class="label ys_txt"><span class="ys_indent2"> 一号车市对您的信息承担保密义务，我们仅会在下列情况下才将您的信息与第三方共享：</span></p>
      <p class="label ys_txt"><span class="ys_indent2">1.事先获得您或您的监护人的同意或授权；</span></p>
      <p class="label ys_txt"><span class="ys_indent2"> 2.为免除您在生命、身体或财产方面的紧急危险；</span></p>
      <p class="label ys_txt"><span class="ys_indent2"> 3.根据法律法规的规定或行政、司法机构的要求；</span></p>
      <p class="label ys_txt"><span class="ys_indent2">
          4.根据法律法规的规定及商业惯例，一号车市需要接受第三方的审计或尽职调査时，可能向其提供您的相关信息；</span></p>
      <p class="label ys_txt"><span class="ys_indent2">5.为了提升一号车市的产品及服务质量或向您提供全新的产品及服务，一号车市会在关联公司内部共享您的相关信息，也可能将一号车市收集的信息提供给第三方用于分析和统计。
        </span></p>
      <p class="label ys_txt"><span class="ys_indent2">6.如果您通过一号车市使用的某些产品及服务是由合作伙伴提供的，或是由一号车市与合作伙伴或供应商共同提供的，一号车市将与其共享向您提供相应产品及服务所必需的信息；</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">7.为了与第三方开展联合推广活动，一号车市可能与其共享开展活动所必需的以及在活动过程中产生的相关信息；</span></p>
      <p class="label ys_txt"><span class="ys_indent2">8.为了维护您的合法权益，在协助处理与您有关的交易纠纷或争议时，一号车市会向您的交易相对方或存在利害关系的第三方提供解决交易纠纷或争议所必需的信息；</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">您同意免除上述个人信息的接收和/或使用方在按照本政策所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。</span></p>
      <p class="label ys_stage">五、信息安全及保护措施</p>
      <p class="label ys_txt"><span class="ys_indent2">一号车市采取严格的管理、技术和物理安全措施来确保所收集的信息不受未经授权的访问、损失、破坏或变更；在提供服务的过程中，一号车市可能会使用第三方的产品或服务，该等第三方只有在必须的情况下才会接触到您的信息，且都受到严格的保密条款等约束；请注意，互联网环境及任何安全系统都存在可能及未知的风险，因为无法做到100%安全。</span>
      </p>
      <p class="label ys_stage">六、未成年人信息保护</p>
      <p class="label ys_txt"><span class="ys_indent2">未满十八岁的未成年人应在其父母或监护人指导下使用一号车市的产品及服务。我们建议未成年人鼓励他们的父母或监护人阅读本隐私权条款，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导，未成年人一旦使用一号车市的产品及服务，我们视为有未成年人父母或监护人的同意或指导。</span>
      </p>
      <p class="label ys_stage">七、变更</p>
      <p class="label ys_txt"><span class="ys_indent2">随着一号车市产品与服务的不断提升，本隐私权条款的内容也可能会不时更新。更新后的隐私条款一旦在一号车市产品上公布即有效代替原来的隐私权条款。我们鼓励您时常查看一号车市产品及服务以了解我们最新的隐私政策。</span>
      </p>
      <p class="label ys_stage">八、第三方SDK相关隐私政策</p>

      <p class="label ys_txt"><span class="ys_indent3"> 1)【友盟+】统计分析服务（具体隐私政策详见：
          <a style="color: #007aff;" href="https://www.umeng.com/page/policy" target="_blank">https://www.umeng.com/page/policy</a>）</span></p>
      <p class="label ys_txt"><span class="ys_indent5"> 1【友盟+】终端统计分析服务（U-App/U-Web）</span></p>
      <p class="label ys_txt"><span class="ys_indent4">【友盟+】统计分析服务帮助您了解您的最终用户如何使用您的产品（含服务，包括但不限于移动应用客户端、移动网站、应用平台、PC网站、站点及【友盟+】确认可提供服务的其他终端等，以下同），并且帮助您分析您的产品在不同终端设备上的表现。当您在产品里集成了【友盟+】统计分析工具之后，您的产品就通过【友盟+】统计分析工具收集和传送数据到我们的服务器。我们收集唯一设备识别码<span class="jiacu">（IMEI/MAC/AndroidID/OAID/IDFA/OpenUDID/GUID/SIM 卡IMSI/ICCID/IP/设备型号/应用安装列表）</span>以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。
        </span></p>
      <p class="label ys_txt"><span class="ys_indent4">
          除上述个人信息外，统计分析服务将根据统计维度的不同采集如下信息：SDK/API/JS代码版本、浏览器、互联网服务提供商、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、设备型号、传感器参数、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent3"> 2)【友盟+】开发者运营工具（具体隐私政策详见：
          <a style="color: #007aff;" href="https://www.umeng.com/page/policy" target="_blank">https://www.umeng.com/page/policy</a>）</span></p>
      <p class="label ys_txt"><span class="ys_indent2">【友盟+】开发者运营工具帮助您在您的产品中整合或搭建消息推送（U-Push）、社会化分享（U-Share）、智能认证（U-Verify）、智能推荐（U-Rec）、应用稳定性监测（U-APM）、智能超链（U-Link）等功能模块。当您在产品里集成了【友盟+】U-Push
          、U-Share和U-Verify等开发者运营工具SDK或API之后，您的产品就通过【友盟+】开发者运营工具SDK或API收集和传送数据到我们的服务器。</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent5"> 1【友盟+】消息推送服务（U-Push）</span></p>
      <p class="label ys_txt"><span class="ys_indent4">【友盟+】消息推送服务，基于全域数据建立的精准消息推送平台，为您提供更灵活、更智能、更有效的消息推送方案，有效提升用户粘性，提高App活跃度。我们采集设备标识符<span class="jiacu">(IMEI/MAC/AndroidID/OAID/IDFA/OpenUDID/GUID/SIM 卡IMSI/ICCID/IP/设备型号/应用安装列表)</span>，用于唯一标识设备，以便向目标设备推送消息。采集地理位置甄别推送通道，提高消息推送的区域覆盖率。</span></p>
      <p class="label ys_txt"><span class="ys_indent4">厂商推送通道SDK包含（小米、华为、oppo、vivo），推送通道SDK需要收集采集设备标识符<span class="jiacu">（IMEI/MAC/AndroidID/OAID/IDFA/OpenUDID/GUID/SIM 卡IMSI/ICCID/IP/设备型号/应用安装列表）</span>，用于唯一标识设备，以便向用户设备推送消息。采集地理位置甄别推送通道，提高消息推送的区域覆盖率。
        </span></p>
      <p class="label ys_txt"><span class="ys_indent4">
          小米推送主要用来给小米公司相关的手机进行消息推送。具体隐私政策详见：<a style="color: #007aff;" href="https://dev.mi.com/distribute/doc/details?pId=1534" target="_blank">https://dev.mi.com/distribute/doc/details?pId=1534</a>
        </span></p>
      <p class="label ys_txt"><span class="ys_indent4">
          华为推送主要用来给华为公司相关的手机进行消息推送。具体隐私政策详见：<a style="color: #007aff;" href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177" target="_blank">https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a>
        </span></p>
      <p class="label ys_txt"><span class="ys_indent4">
          OPPO推送主要用来给OPPO公司相关的手机进行消息推送。具体隐私政策详见：<a style="color: #007aff;" href="https://open.oppomobile.com/new/developmentDoc/info?id=10288" target="_blank">https://open.oppomobile.com/new/developmentDoc/info?id=10288</a>
        </span></p>
      <p class="label ys_txt"><span class="ys_indent4">
          VIVO推送主要用来给VIVO公司相关的手机进行消息推送。具体隐私政策详见：<a style="color: #007aff;" href="https://dev.vivo.com.cn/documentCenter/doc/366" target="_blank">https://dev.vivo.com.cn/documentCenter/doc/366</a>
        </span></p>
      <p class="label ys_txt"><span class="ys_indent5"> 2【友盟+】社会化分享服务（U-Share）</span></p>
      <p class="label ys_txt"><span class="ys_indent4">【友盟+】社会化分享服务，帮助您的应用或游戏快速具备国内外多平台分享功能，并为您提供分享回流等数据分析服务，助力您的产品开发与推广。我们采集设备标识符<span class="jiacu">(IMEI/MAC/AndroidID/OAID/IDFA/OpenUDID/GUID/SIM 卡IMSI/ICCID/IP/设备型号/应用安装列表)</span>以及社交账号公开信息，以便向目标设备以及指定社交账号分享消息。采集地理位置甄别分享通道，提供反作弊服务。</span></p>
      <p class="label ys_stage">九、设备权限调用说明</p>
      <p class="label ys_txt"><span class="ys_indent2">1.电话权限 </span></p>
      <p class="label ys_txt"><span class="ys_indent2">应用内需要识别您的设备身份，需要调用此权限获取此项信息，除此之外不会用于其他用途。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">2.存储权限（读写权限） </span></p>
      <p class="label ys_txt"><span class="ys_indent2">为了存储应用配置文件以及您下载、更新的内容或读取您需要上传、同步的内容，需要调用您的存储权限。</span>
      </p>
      <p class="label ys_txt"><span class="ys_indent2">3.相机权限</span></p>
      <p class="label ys_txt"><span class="ys_indent2">当您使用拍摄或者扫描相关功能时，需要调用您的相机权限。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">4.联系人权限</span></p>
      <p class="label ys_txt"><span class="ys_indent2">当您需要通过通讯录带入联系人信息，需要获取您手机的联系人权限。</span></p>
      <p class="label ys_txt"><span class="ys_indent2">如您想取消上述权限的授权，您可在系统设置-权限管理中关闭，我们将不再获取您的对应权限，但是这可能会影响涉及对应的必要权限功能或服务的使用。</span></p>
      <p class="label ys_stage">十、开发者信息</p>
      <p class="label ys_txt"><span class="ys_indent2">本隐私政策适用于开发者——武汉一号车市科技有限公司旗下客如意。如有疑问，请邮件联系appstore@yhcs.com，我们将在两个工作日或法规规定的时限内予以响应。 </span>
      </p>
    </div>
  </div>

</template>

<script>
export default {
  name: 'privacy_agreement',
}
</script>
<style lang="scss" scoped>
.privacy_agreement {
  color: #333;
  margin: 0;
  padding: 0;
  border: 0;
  list-style: none;
  outline-style: none;
  font-family: Microsoft Yahei;
  padding: 25px 18px 18px;
  font-size: 14px;
  height: 100%;
  overflow-y: scroll;
  text-align: left;

  .label {
    display: flex;
  }

  .ys_title {
    font-size: 19px;
    color: #000;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }

  .ys_date {
    margin-top: 19.5px;
    margin-bottom: 10px;
    display: block;
    text-align: right;
    font-size: 12px;
    color: #000;
  }

  .ys_txt {
    margin-top: 2px !important;
    margin-bottom: 0;
  }

  .ys_indent2 {
    text-indent: 19px;
    color: #000;
  }

  .ys_stage {
    color: #000;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: left;
  }

  .ys_indent3 {
    text-indent: 19px;
    color: #000;
    font-weight: 500;
    text-align: left;
    margin-bottom: 5px;
    display: block;
  }

  .label span {
    line-height: 23px;
  }

  .ys_indent4 {
    text-indent: 30px;
    color: #000;
  }

  .ys_indent5 {
    text-indent: 24px;
    color: #000;
    margin-bottom: 3px;
  }

  .jiacu {
    font-weight: bold;
  }
}
</style>